export const BUKIETY_BUYING_GUIDE = {
  id: 'bukiety',
  eyebrow: 'Pomoc w wyborze bukietu',
  sections: [
    {
      heading: 'Bukiety na urodziny, rocznicę i drobne gesty',
      paragraphs: [
        {
          text: 'Urodzinowy bukiet może nawiązywać do tego, co lubi solenizant: mocnych kolorów, prostych kompozycji albo połączeń różnych kwiatów. Kiedy szukasz prezentu dla osoby, która chętnie otacza się barwami, przyjrzyj się bukietom z gerberami. Wśród kwiatów na urodziny znajdziesz też inne formy prezentu, jeśli chcesz porównać bukiet z kompozycją w pudełku lub koszu.',
          links: [{ text: 'kwiatów na urodziny', href: '/okazje/urodziny/' }],
        },
        {
          text: 'Wybierając kwiaty na rocznicę, możesz wrócić do gatunku lub koloru, który towarzyszył Waszemu pierwszemu spotkaniu. Na podziękowanie za pomoc czy spontaniczną wizytę wystarczy skromniejsza kompozycja, dobrana z myślą o odbiorcy. Przy przeprosinach zadbaj również o kilka własnych słów na bileciku. Wielkość prezentu nie zastąpi wiadomości, którą chcesz przekazać.',
          links: [{ text: 'kwiaty na rocznicę', href: '/okazje/rocznica/' }],
        },
      ],
    },
    {
      heading: 'Jak dopasować bukiet do osoby i okazji?',
      paragraphs: [
        {
          text: 'Zawęź wybór do dwóch lub trzech propozycji i porównaj je według tych samych kryteriów: dominującego koloru, gatunków kwiatów i zawartości wybranego wariantu. Ustal też budżet na całe zamówienie, uwzględniając dostawę, jeśli ma być częścią prezentu.',
        },
      ],
      subsections: [
        {
          heading: 'Kolorystyka i ulubione kwiaty',
          paragraphs: [
            {
              text: 'Dla miłośnika delikatnych odcieni punktem wyjścia mogą być Goździki Pastelowe Marzenie, opisane w katalogu jako połączenie różu, beżu i kremu. Gerbery Peach Pink zestawiają róż z brzoskwiniowym kolorem. Jeśli odbiorca lubi bardziej urozmaicone układy, Roztańczone Gerbery łączą gerbery, goździki i eustomy. Te przykłady pomagają ocenić, czy szukasz jednego dominującego gatunku, czy bukietu mieszanego. Przy nieznanym guście postaw na ograniczoną paletę barw i prosty układ. Nie musisz przypisywać każdemu kolorowi ukrytego znaczenia.',
            },
          ],
        },
        {
          heading: 'Wielkość oraz styl kompozycji',
          paragraphs: [
            {
              text: 'Oznaczenie „mały” lub „duży” czytaj razem ze składem konkretnego produktu. Warianty bukietów z gipsówką, gerberami czy goździkami mają różne liczby kwiatów, więc sama nazwa rozmiaru nie wystarczy do ich porównania. Zwróć uwagę również na kształt kwiatów, dodatki i oprawę widoczną na zdjęciu. Na rodzinny jubileusz możesz rozważyć obszerniejszy bukiet, a do wręczenia podczas krótkiego spotkania mniejszy. Pomyśl też o wazonie i miejscu, w którym kwiaty będą stały. Jeżeli zależy Ci na formie w pudełku, porównaj flower boxy.',
              links: [{ text: 'flower boxy', href: '/flower-boxy/' }],
            },
          ],
        },
      ],
    },
    {
      heading: 'Bukiety z dostawą w Lublinie',
      paragraphs: [
        {
          text: 'Bukiet z dostawą pozwala zaplanować prezent także wtedy, gdy w dniu uroczystości jesteś poza Lublinem. Podaj adres, pod którym odbiorca będzie mógł odebrać kwiaty, oraz jego numer telefonu. Przy doręczeniu do pracy przydadzą się nazwa firmy i wskazówki dotyczące wejścia. Bilecik z podpisem pomoże od razu rozpoznać nadawcę.',
        },
        {
          text: 'Zanim sfinalizujesz zakup, sprawdź dostępny dzień, przedział godzinowy i koszt przesyłki kwiatowej dla podanego adresu. Zasady dostawy wyjaśniają również, jak wygląda kontakt przy nieobecności odbiorcy. Gdy kwiaty mają towarzyszyć konkretnemu wydarzeniu, uwzględnij jego porę przy wyborze dostępnego terminu.',
          links: [{ text: 'Zasady dostawy', href: '/dostawa/' }],
        },
      ],
    },
    {
      heading: 'Gotowy bukiet czy kompozycja według Twojego pomysłu?',
      paragraphs: [
        {
          text: 'Bukiet z katalogu ułatwia decyzję, gdy odpowiada Ci pokazane zestawienie kwiatów i oprawa. Wybierasz konkretny produkt, a następnie jedną z opcji dostępnych na jego karcie. To dobry punkt wyjścia również wtedy, gdy wiesz, jaki efekt Ci się podoba, ale nie potrafisz nazwać wszystkich kwiatów.',
        },
        {
          text: 'Masz na myśli bukiet róż w określonym kolorze i liczbie? Sprawdź dostępne bukiety róż i ich warianty. Jeśli planujesz zmianę, której karta produktu nie przewiduje, skontaktuj się z kwiaciarnią przed zakupem i opisz swój pomysł. Po ustaleniu kompozycji pozostaje dopisać życzenia i wybrać sposób przekazania kwiatów.',
          links: [{ text: 'bukiety róż', href: '/kwiaty/roze/' }],
        },
      ],
    },
  ],
} as const;
